import { TimePicker } from "antd";
import { Dayjs } from "dayjs";
import React, { useMemo } from 'react';
import { IPropsElement } from "../../../pages/ChecklistPage/PopupEdit/constants";
import { datetime } from "../../../util/library/datetime";
import { propContainer } from "../../../util/varibles/constants";
import { callEventChecklist, getChecklist, useChecklist } from "../ChecklistContext";

const format = 'HH:mm'

const TimeElement: React.FC<IPropsElement> = (props) => {
    const { index } = props;
    const [value] = useChecklist(state => state.result[index]);
    const { isTimeRange, ...args } = props.properties;
    const { onResultChange } = callEventChecklist();
    const { disabled } = getChecklist()();
    const Component = isTimeRange ? TimePicker.RangePicker : TimePicker;
    const convertValue = useMemo(() => {
        if (isTimeRange && Array.isArray(value)) {
            const start = datetime(value[0]);
            const finish = datetime(value[1]);
            const result: [null | Dayjs, null | Dayjs] = [null, null];
            if (start.isValid) {
                result[0] = start.value;
            }
            if (finish.isValid) {
                result[1] = finish.value;
            }
            return result;
        } else if (value) {
            const time = datetime(value)
            return time.isValid ? time.value : undefined;
        } else {
            return undefined
        }
    }, [value, isTimeRange]);

    return <Component
        {...propContainer}
        {...args}
        format={format}
        disabled={disabled}
        value={convertValue}
        onChange={value => {
            if (Array.isArray(value)) {
                onResultChange({ [index]: [datetime(value[0]).time, datetime(value[1]).time] })
            } else {
                onResultChange({ [index]: datetime(value).time })
            }
        }}
    />;
};

export default TimeElement;
